import type { CreditCard } from "schema/gen/es/chiikipoint/model/v2/model_pb";

const pendingRegisteredCreditCardKey =
  "chiikipoint.pendingRegisteredCreditCard";

type PendingRegisteredCreditCard = {
  cardVerificationId: string;
  amount: number;
};

export function setPendingRegisteredCreditCard(
  pending: PendingRegisteredCreditCard,
) {
  localStorage.setItem(pendingRegisteredCreditCardKey, JSON.stringify(pending));
}

export function consumePendingRegisteredCreditCard(
  amount: number,
  cards: CreditCard[],
) {
  const item = localStorage.getItem(pendingRegisteredCreditCardKey);
  if (!item) {
    return null;
  }

  localStorage.removeItem(pendingRegisteredCreditCardKey);

  try {
    const pending = JSON.parse(item) as Partial<PendingRegisteredCreditCard>;
    if (
      pending.amount !== amount ||
      typeof pending.cardVerificationId !== "string"
    ) {
      return null;
    }

    return (
      cards.find(
        (card) =>
          card.billingAddress?.cardVerificationId ===
          pending.cardVerificationId,
      )?.gmoCardId ?? null
    );
  } catch {
    return null;
  }
}
